import SEO from '@/components/shared/SEO'
import KeyInformation from '@/components/KeyInformation'
import CTAButton from '@/components/shared/CTAButton'
import USPBanner from '@/components/USPBanner'
import TrustpilotBadge from '@/components/TrustpilotBadge'
import ReferralProgramBody from '@/components/ReferralProgramBody'
import ReferralProcessSection from '@/components/ReferralProcessSection'
import ReferralFAQ from '@/components/ReferralFAQ'

const ReferralProgram = () => {
  const referralFaqs = [
    {
      question: 'How do I invite friends to claim with Claims1?',
      answer:
        "It's easy! As soon as you sign up, you'll receive your QR code which you can share directly to Facebook, X, LinkedIn, or via email.",
    },
    {
      question: 'How much do I get for sharing Claims1 with my friends?',
      answer:
        "For every friend who successfully claims compensation using your unique QR code, you'll receive a £10 prepaid gift card by email. We'll send these every month for eligible successful claims.",
    },
    {
      question: 'How long is my link or QR code valid for?',
      answer:
        'Your unique code will not expire and is valid from the moment you receive it, so feel free to start sharing it with your friends, family and colleagues.',
    },
    {
      question: 'How will I receive my reward if my friend files a claim?',
      answer:
        'When your friend receives their compensation, you will receive an email notifying you that your reward has been approved, together with instructions on how to redeem your gift card. All valid rewards are paid out every month.\n\nOnce your reward is approved, it may take up to 7 days for you to receive your gift card.',
    },
    {
      question: 'Is there a limit on the number of friends I can refer?',
      answer:
        'You can receive rewards for up to 100 friends using your unique code.',
    },
    {
      question: 'How do I redeem my reward?',
      answer:
        "You'll receive an email together with instructions on how to redeem and use your prepaid gift card, which can be used online with thousands of retailers where it's accepted.",
    },
    {
      question:
        "Why didn't I receive a reward even though my friend filed a claim?",
      answer:
        "If your friend's claim for compensation isn't successful, you won't receive a reward. See the Terms and Conditions for more information.",
    },
    {
      question:
        "What if my friend has submitted an accepted claim but I didn't receive a reward?",
      answer:
        "If your friend had a successful claim but you didn't receive a reward, check if your friend used your unique QR code. They have to use your unique QR code for us to confirm your reward.\n\nIf it's correct and you still haven't received anything, email our support team: help@claim1.co.uk",
    },
    {
      question: 'What are the terms and conditions?',
      answer:
        'You can view our referral program terms and conditions here www.claims1.co.uk/referralterms',
    },
  ]

  return (
    <div className="flex-1">
      <SEO
        title="Referral Program - Claims1 | Car Finance Claims UK"
        description="Join the Claims1 referral program and help others claim compensation for mis-sold car finance while earning rewards."
        keywords="referral program, Claims1, car finance claims, refer a friend, rewards"
        url="/referral-program"
        image="/Image/Car-photo-illustration-claims1.webp"
        imageAlt="Claims1 Referral Program"
        schemaType="WebPage"
        breadcrumbs={[
          { name: 'Home', url: '/' },
          { name: 'Referral Program', url: '/referral-program' },
        ]}
      />

      <USPBanner />
      <div
        className="relative flex min-h-[70vh] items-center md:min-h-[91vh]"
        style={{
          backgroundImage: 'url("/Image/Claims1-referral-program.webp")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className="absolute inset-0 bg-black/53"></div>
        <div className="relative z-10 container mx-auto px-4 py-8">
          <div className="px-4 text-center lg:px-20">
            <h1 className="mb-4 text-center text-4xl font-black tracking-tight text-white uppercase sm:mb-6 sm:text-6xl">
              Help Your Friends To Get Compensation and Get Rewarded!
            </h1>
            <p className="font-raleway-numbers mx-auto mb-4 max-w-xl text-lg leading-relaxed font-bold text-white/90 sm:text-xl md:mb-6 md:max-w-3xl lg:text-2xl">
              Help your friends and family claim what they&apos;re owed from
              mis-sold car finance.
            </p>
            <div className="mt-6 flex justify-center">
              <CTAButton text="SHARE YOUR CODE NOW" disabled={true} />
            </div>
            <div className="mt-6 flex justify-center md:mt-12">
              <TrustpilotBadge rating="4star" />
            </div>
          </div>
        </div>
      </div>

      <ReferralProgramBody />

      <ReferralProcessSection />

      <ReferralFAQ
        faqs={referralFaqs}
        title="FREQUENTLY ASKED QUESTIONS"
        includeStructuredData={false}
      />

      <KeyInformation />
    </div>
  )
}

export default ReferralProgram
